import { cn } from '@/lib/utils';

const MIN_BAR_HEIGHT = 5;
const BAR_RANGE = 17;

type WaveformProps = {
  /** Normalised bar heights, 0–1. */
  peaks: number[];
  /** Playback position, 0–1 — bars up to here are filled. */
  progress: number;
  className?: string;
};

/**
 * Voice playback waveform (OTC prototype): flat stone bars that fill green as
 * the clip plays (GIFTWEB-21 AC 5).
 */
function Waveform({ peaks, progress, className }: WaveformProps) {
  const played = progress * peaks.length;

  return (
    <div
      aria-hidden='true'
      data-testid='voice-waveform'
      className={cn(
        'flex h-[26px] min-w-0 flex-1 items-center gap-[2.5px] overflow-hidden',
        className,
      )}
    >
      {peaks.map((peak, index) => (
        <span
          key={index}
          style={{ height: MIN_BAR_HEIGHT + Math.round(BAR_RANGE * peak) }}
          className={cn(
            'min-w-[2px] flex-1 rounded-[2px]',
            index < played ? 'bg-[#256956]' : 'bg-[#d9d2c7]',
          )}
        />
      ))}
    </div>
  );
}

export default Waveform;
